export default {"src":"/_next/static/media/tencent-cloud.c09e0448.svg","height":720,"width":1053,"blurWidth":0,"blurHeight":0};